var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/share_white.64744b59.png","uri@2x": __webpack_public_path__ + "static/media/share_white.672a9185.png","uri@3x": __webpack_public_path__ + "static/media/share_white.28625a93.png",
    width: 16,
    height: 18
});